
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'ColorModuleRequest',
})
export default class ColorModuleRequest extends Vue {
    @Prop({ required: true }) private value!: any;
    @Prop({ required: true }) private validationErrors!: any;
}
